import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import {
  JobList,
  MasQuitReason,
  SexFlug,
  YesOrNoFlug,
} from "../../assets/data/Constants";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkStepper from "../../components/atoms/TkStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkTable from "../../components/atoms/TkTable";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { TkRouteContext } from "../../context/tkRouteContext";
import { TkGetCode } from "../../utils/TkGetCode";
import { changeAmountFormat } from "../../utils/useTools";
import { getBodyList, getHeadList } from "./hooks/useHooks";
import { IAPI_STA015_Request } from "../../type/apiType";
import { httpAPI_STA015 } from "./api/request";
import { fakeTableList, stepperData } from "./parts";
import "./_style.scss";
import { CheckedList } from "../../type/apiType/IAPI_STA015";
import _ from "lodash";

/**
 * SCRC060009 加入登録手続き　内容確認
 * @return SCRC060009
 */
const SCRC060009 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const isDaiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.DAIKOSHA;
  const businessType = businessState.common?.businessType;
  // チェック済みリスト
  const [checkedList, setCheckedList] = useState<CheckedList[]>([]);

  const job =
    businessType === "JOB-01"
      ? "job_01"
      : businessType === "JOB-15"
      ? "job_15"
      : "job_23";
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));

  // 初期表示
  const handleInit = () => {
    let resArr = stateFakeTableList.current;

    const contextData = businessState[job]?.registrationProcedureInfo as {
      [key: string]: any;
    };

    for (let i in contextData) {
      let targetObj = resArr.find((item) => item.keyword === i)!;

      targetObj && (targetObj.text = contextData?.[i]);
    }

    resArr.find((item) => item.keyword === "transferCd")!.text =
      contextData?.transferCd;

    resArr.find((item) => item.keyword === "facilityNameList")!.text =
      (contextData?.facilityNo ?? "") + ":" + (contextData?.facilityName ?? "");

    resArr.find((item) => item.keyword === "sex")!.text = TkGetCode(
      SexFlug,
      contextData?.sex
    );

    resArr.find((item) => item.keyword === "jobCd")!.text = TkGetCode(
      JobList,
      contextData?.jobCd
    );

    resArr.find((item) => item.keyword === "salaryTableAmt")!.text =
      changeAmountFormat(contextData?.salaryTableAmt ?? "") + "円";

    resArr.find((item) => item.keyword === "salaryAdjustmentAmt")!.text =
      contextData?.salaryAdjustmentAmt
        ? changeAmountFormat(contextData?.salaryAdjustmentAmt ?? "") + "円"
        : "";

    resArr.find((item) => item.keyword === "masPastFlg")!.text = TkGetCode(
      YesOrNoFlug,
      contextData?.masPastFlg
    );

    resArr.find((item) => item.keyword === "masQuitReason")!.text = TkGetCode(
      MasQuitReason,
      contextData?.masQuitReason
    );

    let isShowData =
      contextData?.masPastFlg === YesOrNoFlug["有"] &&
      (contextData?.masQuitReason === MasQuitReason["解除"] ||
        contextData?.masQuitReason === MasQuitReason["合算申出"]);

    let bContractName = resArr.find(
      (item) => item.keyword === "bContractName"
    )!;

    bContractName.text = contextData?.bContractName;
    bContractName.showLine = isShowData;

    let bContractNo = resArr.find((item) => item.keyword === "bContractNo")!;
    bContractNo.text = contextData?.bContractNo;
    bContractNo.showLine = isShowData;

    let bStaffNo = resArr.find((item) => item.keyword === "bStaffNo")!;
    bStaffNo.text = contextData?.bStaffNo;
    bStaffNo.showLine = isShowData;

    const employee = resArr.find((item) => item.keyword === "employee")!;

    if (
      contextData &&
      contextData?.year &&
      contextData?.year !== 0 &&
      contextData.apr &&
      contextData.may &&
      contextData.jun &&
      contextData.jul &&
      contextData.aug &&
      contextData.sep &&
      contextData.oct &&
      contextData.nov &&
      contextData.dec &&
      contextData.jan &&
      contextData.feb &&
      contextData.mar
    ) {
      const headListData = getHeadList(contextData?.year!);
      const bodyListData = getBodyList(contextData);
      employee.node = (
        <Box className="table">
          <TkTable headList={headListData} bodyList={[bodyListData]}></TkTable>
        </Box>
      );
      employee.text = "1年目";
      employee.showLine = true;
    } else {
      employee.showLine = false;
    }

    let contractorName = resArr.find(
      (item) => item.keyword === "contractorName"
    )!;
    contractorName.showLine = isKiko;
    contractorName.contractorNumber =
      businessState.common?.contractorNo +
      ":" +
      businessState.common?.contractorName;

    setStateTableList(resArr);
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convertMonthValue = (value: string | undefined): string => {
    return value === "1" || value === "3" ? "1" : "0";
  };

  const getParamData = (): IAPI_STA015_Request => {
    let upData: IAPI_STA015_Request = {
      contractorNo: isKiko
        ? businessState.common?.contractorNo!
        : state.authInfo?.contractorNo!,
      applyId: businessState[job]?.applyId,
      tempSaveStep: 2,
      businessType: businessState.common?.businessType!,
      transferCd: businessState[job]?.registrationProcedureInfo?.transferCd,
      facilityNo: businessState[job]?.registrationProcedureInfo?.facilityNo!,
      staffNo: businessState[job]?.registrationProcedureInfo?.staffNo,
      staffNameKana:
        businessState[job]?.registrationProcedureInfo?.staffNameKana,
      staffNameKanji:
        businessState[job]?.registrationProcedureInfo?.staffNameKanji!,
      birthday: businessState[job]?.registrationProcedureInfo?.birthday!,
      sex: businessState[job]?.registrationProcedureInfo?.sex!,
      masPastFlg: businessState[job]?.registrationProcedureInfo?.masPastFlg,
      masQuitReason:
        businessState[job]?.registrationProcedureInfo?.masQuitReason,
      masQuitDate: businessState[job]?.registrationProcedureInfo?.masQuitDate,
      bContractName:
        businessState[job]?.registrationProcedureInfo?.bContractName,
      bContractNo: businessState[job]?.registrationProcedureInfo?.bContractNo,
      bStaffNo: businessState[job]?.registrationProcedureInfo?.bStaffNo,
      joinDate: businessState[job]?.registrationProcedureInfo?.joinDate,
      joinCapacity:
        businessState[job]?.registrationProcedureInfo?.joinCapacity!,
      jobCd: businessState[job]?.registrationProcedureInfo?.jobCd!,
      salaryTableAmt:
        businessState[job]?.registrationProcedureInfo?.salaryTableAmt,
      salaryAdjustmentAmt:
        businessState[job]?.registrationProcedureInfo?.salaryAdjustmentAmt,
      year: businessState[job]?.registrationProcedureInfo?.year,
      apr: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.apr
      ),
      may: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.may
      ),
      jun: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.jun
      ),
      jul: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.jul
      ),
      aug: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.aug
      ),
      sep: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.sep
      ),
      oct: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.oct
      ),
      nov: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.nov
      ),
      dec: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.dec
      ),
      jan: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.jan
      ),
      feb: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.feb
      ),
      mar: convertMonthValue(
        businessState[job]?.registrationProcedureInfo?.mar
      ),
      receptionDate: "",
      screenId: "SCRC060009",
      checkedList: checkedList,
    };

    return upData;
  };

  const onCheckAndSubmit = async (_data: any, index: any) => {
    // 加入登録手続き更新API呼び出し
    try {
      const res = await httpAPI_STA015({
        ...getParamData(),
      });

      setCheckedList(res.checkedList || []);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setCheckedList([]);

        switch (index) {
          case 0: // 同じ施設で続けて登録
            setBusinessState({
              ...businessState,
              [job]: {
                ...businessState[job],
                tempSaveStep: 2,
                applyId: res?.applyId,
                registrationProcedureInfo: {},
                facilityNo:
                  businessState[job]?.registrationProcedureInfo?.facilityNo,
                facilityName:
                  businessState[job]?.registrationProcedureInfo?.facilityName,
                staffNo: null,
              },
            });
            navigate("/SCRC060108");
            break;
          case 1: // 違う施設で続けて登録
            setBusinessState({
              ...businessState,
              [job]: {
                ...businessState[job],
                tempSaveStep: 2,
                applyId: res?.applyId,
                registrationProcedureInfo: {},
                facilityNo: null,
                facilityName: null,
                staffNo: null,
              },
            });
            navigate("/SCRC060108", { state: { signUpFlg: true } });
            break;

          default: // 入力完了
            setBusinessState({
              ...businessState,
              [job]: {
                ...businessState[job],
                applyId: res?.applyId,
                registrationProcedureInfo: {},
              },
            });

            // API呼び出しの結果、正常終了した場合 遷移元画面に戻る
            let routerList = stateRouter.routerList || [];
            if (routerList.length > 1) {
              if (
                location.pathname === "/SCRC060106" ||
                businessType === "JOB-01"
              ) {
                navigate("/SCRC060106");
              } else if (
                location.pathname === "/SCRC050104" ||
                businessType === "JOB-15"
              ) {
                navigate("/SCRC050104");
              } else {
                navigate("/SCRC060110", { state: { deleteFlg: true } });
              }
            } else {
              // エラー内容を表示する。
              setStateRouter({
                ...state,
                routerList: [...[]],
              });
              navigate("/error");
            }
            break;
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box className="SCRC060009" data-testid="SCRC060009PageForTest">
      <TkStepper steps={stepperData} activeStep={1} />

      <TkFakeTable
        list={stateTableList}
        ruleSchema={{}}
        onCheckAndSubmit={(data, index) => onCheckAndSubmit(data, index)}
        buttonGroup={<TkBackButton useBackParam />}
        submitButtonGroup={[
          {
            submitButtonText: "同じ施設で続けて入力",
            showButton: !(
              businessType === "JOB-01" || businessType === "JOB-15"
            ),
          },
          {
            submitButtonText: "違う施設で続けて入力",
            showButton:
              !(businessType === "JOB-01" || businessType === "JOB-15") &&
              !isDaiko,
          },
          { submitButtonText: "入力完了", showButton: true },
        ]}
      />
    </Box>
  );
};

export default SCRC060009;
